import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, Fingerprint, Activity } from 'lucide-react';
export function Method() {
  const pillars = [{
    icon: <Sparkles size={32} className="text-rosegold" data-id="element-191" />,
    title: 'Energía',
    description: 'Aprende a regular tu sistema nervioso y gestionar tu energía vital para dejar de operar desde el agotamiento y la ansiedad.'
  }, {
    icon: <Fingerprint size={32} className="text-rosegold" data-id="element-192" />,
    title: 'Identidad',
    description: 'Alinea quién eres hoy con la mujer en la que te quieres convertir. Rompe creencias limitantes y reprograma tu autoconcepto.'
  }, {
    icon: <Activity size={32} className="text-rosegold" data-id="element-193" />,
    title: 'Acción',
    description: 'Sostén acciones reales y consistentes. Deja la procrastinación y construye hábitos que te acerquen a tu visión extraordinaria.'
  }];
  return <section id="metodo" className="py-24 bg-cream pt-[9px] pb-[9px]" data-id="element-194">
      <div className="max-w-7xl mx-auto px-6" data-id="element-195">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-196">
          <h2 className="text-3xl md:text-4xl font-serif text-burgundy mb-4" data-id="element-197">
            Qué es el Método Coherencia Femenina
          </h2>
          <p className="text-lg text-taupe max-w-2xl mx-auto" data-id="element-198">
            Un sistema probado basado en tres pilares fundamentales para
            transformar tu realidad desde adentro hacia afuera.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10" data-id="element-199">
          {pillars.map((pillar, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="magic-glow bg-white p-10 rounded-3xl shadow-sm hover:shadow-md transition-shadow text-center flex flex-col items-center pt-[20px] pb-[20px] pl-[20px] pr-[20px] relative" data-id="element-200">
              <div className="absolute -top-5 w-10 h-10 diamond-spin drop-shadow-[0_0_6px_rgba(212,132,154,0.6)]" data-id="element-201">
                <svg viewBox="0 0 100 100" className="w-full h-full" data-id="element-202">
                  <defs data-id="element-203">
                    <linearGradient id={`dGrad${index}`} x1="0%" y1="0%" x2="100%" y2="100%" data-id="element-204">
                      <stop offset="0%" stopColor="#F5E0E8" data-id="element-205" />
                      <stop offset="40%" stopColor="#D4849A" data-id="element-206" />
                      <stop offset="70%" stopColor="#E8B0C5" data-id="element-207" />
                      <stop offset="100%" stopColor="#A06080" data-id="element-208" />
                    </linearGradient>
                  </defs>
                  <polygon points="50,5 90,35 75,90 25,90 10,35" fill={`url(#dGrad${index})`} stroke="#D4849A" strokeWidth="1" data-id="element-209" />
                  <polygon points="50,5 90,35 50,35" fill="#FFF5F8" fillOpacity="0.5" data-id="element-210" />
                  <polygon points="50,5 10,35 50,35" fill="#E8B0C5" fillOpacity="0.6" data-id="element-211" />
                  <polygon points="50,35 90,35 75,90" fill="#D4849A" fillOpacity="0.4" data-id="element-212" />
                  <polygon points="50,35 10,35 25,90" fill="#C97A94" fillOpacity="0.5" data-id="element-213" />
                  <polygon points="50,35 75,90 25,90" fill="#FFF5F8" fillOpacity="0.3" data-id="element-214" />
                  <polygon points="50,5 55,20 50,35 45,20" fill="white" fillOpacity="0.7" data-id="element-215" />
                </svg>
              </div>
              <div className="w-16 h-16 bg-cream rounded-full flex items-center justify-center mb-6" data-id="element-216">
                {pillar.icon}
              </div>
              <h3 className="text-2xl font-serif text-burgundy mb-4" data-id="element-217">
                {pillar.title}
              </h3>
              <p className="text-taupe leading-relaxed" data-id="element-218">{pillar.description}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}